import request from '../utils/request'

//登录
export function login(data) {
    return request({
      url: '/login',
      method: 'post',
      data: data
    })
  }

  //获取个人信息
  export function getInfo() {
    return request({
      url: '/getInfo',
      method: 'get'
    })
  }

  //获取当前届次
  export function getSession() {
    return request({
      url: '/period/period/list/tokensession',
      method: 'get'
    })
  }

  //获取当前课题
  export function getMatch() {
    return request({
      url: '/matchquestioninformation/matchquestioninformation/list/tokensession',
      method: 'get'
    })
  }



// WEBPACK FOOTER //
// ./src/api/api.js